import { useTranslation } from 'libs/i18n'
import { useParams } from 'libs/router'
import { routes } from 'config/routes'
import { Header, HistoryButton, BackButton } from 'shared/components'

export const HeaderSection = () => {
	const { t } = useTranslation()
	const params = useParams()

	return (
		<Header
			title={t('Sales / Sale object')}
			actions={
				<>
					<BackButton to={routes.saleIndex} />
					<HistoryButton to={`/sales/${params.id}/history`} />
				</>
			}
		/>
	)
}
